import React from 'react';
import Loadable from 'react-loadable';

const SearchNlDoetLazy = Loadable({
  loader: () => import('./index.lazy'),
  loading: () => (<div />),
});

export default SearchNlDoetLazy;
